<template>
  <div class="shopping-lists wrapper">
    <v-progress-circular
      :size="50"
      color="#1abc9c"
      indeterminate
      v-if="loading"
    ></v-progress-circular>
    <v-card v-if="!loading" class="mx-auto">
      <v-list two-line subheader>
        <v-list-item v-if="userLists.length == 0 && !loading">
          <h3>You have no lists.</h3>
        </v-list-item>
        <v-list-item
          v-else
          v-for="item in userLists"
          :key="item.list_name"
          class="list-item"
        >
          <v-list-item-avatar>
            <v-icon>mdi-view-list</v-icon>
          </v-list-item-avatar>

          <v-list-item-content @click="openList(item.list_id, item.id)">
            <v-list-item-title v-text="item.list_name"></v-list-item-title>
            <v-list-item-subtitle
              v-text="$options.filters.formatDate(item.createdOn)"
            ></v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action v-if="item.user_role === 'creator'">
            <v-btn icon>
              <v-icon
                @click="openCreateListModalForEdit(item)"
                color="grey lighten-1"
                >mdi-pencil</v-icon
              >
            </v-btn>
          </v-list-item-action>
          <v-list-item-action>
            <v-btn icon>
              <v-icon @click="deleteUserList(item)" color="grey lighten-1"
                >mdi-delete</v-icon
              >
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card>

    <v-btn
      color="#1abc9c"
      dark
      big
      fixed
      bottom
      right
      fab
      style="bottom: 75px"
      @click="openCreateListModal"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <transition name="fade">
      <div v-if="showCreateListModal" class="create-modal">
        <div class="create-container">
          <a @click="closeCreateListModal">Close</a>
          <p v-if="shouldEdit">Edit list</p>
          <p v-else>Add a new list</p>
          <v-form
            @submit.prevent
            ref="form"
            v-model="form.valid"
            lazy-validation
          >
            <v-text-field
              v-model="form.name"
              label="Name"
              required
            ></v-text-field>
            <v-radio-group v-model="form.type" row>
              <v-radio label="Normal list" value="normal"></v-radio>
              <v-radio label="Checklist" value="check"></v-radio>
              <v-radio label="Wish list" value="wish"></v-radio>
            </v-radio-group>
            <v-textarea v-model="form.info" label="Description"></v-textarea>
            <button @click="addList" class="button">Confirm</button>
          </v-form>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../firebaseConfig.js");

export default {
  name: "MyShoppingList",
  data: () => ({
    loading: false,
    unsubscribeListener: null,
    shouldEdit: false,
    form: {
      valid: false,
      name: "",
      info: "",
      type: "normal",
      id: ""
    },
    showCreateListModal: false
  }),
  computed: {
    ...mapState(["userProfile", "currentUser", "userLists"])
  },
  methods: {
    fetchUserLists() {
      this.unsubscribeListener = fb.userListsCollection
        .where("user_id", "==", this.currentUser.uid)
        .orderBy("sortOrder")
        .onSnapshot(querySnapshot => {
          let listsArray = [];

          querySnapshot.forEach(doc => {
            let list = doc.data();
            list.id = doc.id;
            listsArray.push(list);
          });
          this.$store.commit("setUserLists", listsArray);
          this.loading = false;
        });
    },
    openCreateListModal() {
      this.showCreateListModal = true;
    },
    openCreateListModalForEdit(list) {
      console.log(list.list_name);
      this.form.name = list.list_name;
      this.form.type = list.list_type;
      this.form.info = list.list_info;
      this.form.id = list.list_id;
      this.shouldEdit = true;
      this.showCreateListModal = true;
    },
    closeCreateListModal() {
      this.form.name = "";
      this.form.info = "";
      this.form.id = "";
      this.shouldEdit = false;
      this.showCreateListModal = false;
    },
    openList(listId, userListId) {
      this.$router.push({
        name: "list",
        params: { user_list_id: userListId, id: listId }
      });
    },
    editList(listId) {
      fb.listsCollection
        .doc(listId)
        .update({
          list_name: this.form.name,
          list_info: this.form.info,
          list_type: this.form.type
        })
        .then(() => {
          //Update userLists
          fb.userListsCollection
            .where("list_id", "==", listId)
            .get()
            .then(snapshot => {
              console.log(snapshot.docs);
              snapshot.docs.forEach(doc => {
                fb.userListsCollection.doc(doc.id).update({
                  list_name: this.form.name,
                  list_info: this.form.info,
                  list_type: this.form.type
                });
              });
              this.shouldEdit = false;
              this.closeCreateListModal();
            });
        })
        .catch(err => {
          console.log(err);
        });
    },
    addList() {
      if (this.shouldEdit) this.editList(this.form.id);
      else this.addNewList();
    },
    addNewList() {
      var list = {
        name: this.form.name,
        type: this.form.type,
        info: this.form.info
      };

      var newList = {
        createdOn: new Date(),
        total_items: 0,
        items_bought: 0,
        list_name: list.name,
        list_info: list.info,
        list_type: list.type,
        user_id: this.currentUser.uid,
        user_name: this.userProfile.name,
        users: [
          {
            id: this.currentUser.uid,
            userName: this.userProfile.name,
            email: this.currentUser.email,
            role: "creator"
          }
        ]
      };

      fb.listsCollection
        .add(newList)
        .then(doc => {
          var newUserList = {
            createdOn: new Date(),
            total_items: 0,
            items_bought: 0,
            list_name: list.name,
            list_info: list.info,
            list_type: list.type,
            list_id: doc.id,
            user_id: this.currentUser.uid,
            user_name: this.userProfile.name,
            user_role: "creator"
          };

          fb.userListsCollection
            .where("user_id", "==", this.currentUser.uid)
            .orderBy("sortOrder", "desc")
            .limit(1)
            .get()
            .then(snap => {
              var sortOrder = 1;
              if (snap.size > 0) {
                sortOrder = snap.docs[0].data().sortOrder + 1;
              }

              newUserList.sortOrder = sortOrder;

              fb.userListsCollection
                .add(newUserList)
                .then(userListDoc => {
                  this.$router.push({
                    name: "list",
                    params: { user_list_id: userListDoc.id, id: doc.id }
                  });
                })
                .catch(err => {
                  console.log(err);
                });
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(err => {
          console.log(err);
        });
    },
    deleteUserList(userList) {
      if (!confirm("Are you sure you want to delete this list?")) {
        return;
      }
      fb.userListsCollection
        .doc(userList.id)
        .delete()
        .then(() => {
          fb.listItemsCollection
            .where("user_list_id", "==", userList.id)
            .get()
            .then(listItemsSnap => {
              listItemsSnap.forEach(doc => {
                doc.ref.delete();
              });
            })
            .catch(err => {
              console.log(err);
            });

          fb.userListsCollection
            .where("list_id", "==", userList.list_id)
            .get()
            .then(snap => {
              if (snap.size === 0) {
                this.deleteList(userList.list_id);
              } else {
                let listRef = fb.listsCollection.doc(userList.list_id);
                listRef.get().then(doc => {
                  listRef.update({
                    users: doc
                      .data()
                      .users.filter(user => user.id !== this.currentUser.uid)
                  });
                });
              }
            });
        })
        .catch(err => {
          console.log(err);
        });
    },
    deleteList(listId) {
      fb.listsCollection
        .doc(listId)
        .delete()
        .then(() => {
          fb.distinctListItemsCollection
            .where("list_id", "==", listId)
            .get()
            .then(snap => {
              snap.forEach(doc => {
                doc.ref.delete();
              });
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  created() {
    this.loading = true;
    this.fetchUserLists();
  },
  destroyed() {
    this.unsubscribeListener();
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("D MMM, YYYY");
    }
  }
};
</script>

<style lang="scss">
.shopping-lists.wrapper {
  margin-top: 10px;
}
.v-list {
  padding: 0;
}

.list-item {
  cursor: pointer;
}

.v-list-item {
  border-bottom: 1px solid #e6ecf0;
}

.create-modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(#000, 0.4);
  z-index: 999;

  .create-container {
    position: relative;
    max-width: 600px;
    margin: 30vh auto 0;
    padding: 2rem;
    border-radius: 3px;
    background: #fff;
    box-shadow: 0 0 20px 0 rgba(#000, 0.5);

    label {
      text-align: left;
    }

    input {
      border: none;
      margin-bottom: 0;
    }

    a {
      position: absolute;
      top: 5px;
      right: 10px;
      padding: 5px;
    }
    .button {
      margin-top: 1rem;
    }
  }
}
</style>
